setTimeout(() => {
    if(BSS_B2B){
            const searchBar = document.querySelector('#predictive-search-results');
            if(searchBar){
                const observer = new MutationObserver((MutationList) =>{

                    for(let item of MutationList){
                        if(item.target.id === 'predictive-search-results' && item.type === 'attributes'){
                            console.log(item);
                        BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');    
                        }
                    }
                })
                observer.observe(searchBar, {childList: true, subtree: true, attributes: true})
            }
            if(window.location.pathname.includes('/products/')){
                setTimeout(() => {window.dispatchEvent(new Event('scroll'));}, 500)
            }

            //mini-cart
            const cartModal = document.querySelector('.cart-drawer__dialog');
            if(cartModal){
                const observer = new MutationObserver((MutationList) =>{
                    for(let item of MutationList){
                        if(item.target.className.includes('cart-drawer__dialog') && item.type === 'attributes'){
                             console.log(1)
                            BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
                            BSS_B2B.observer.cartSubject.listenCartCheckout();
                        }
                        if(item.target.localName === 'cart-items-component' && item.attributeName === 'class'){
                            console.log(2)
                            BSS_B2B.observer.cartSubject.listenCartCheckout();
                        }
                    }
                })
                observer.observe(cartModal, { attributes: true, subtree: true, childList: true})
            }
    }

}, 500)